import React, { useEffect, useState } from 'react';
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { Modal, Form, Col } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import useAuth from "hooks/useAuth"
import 'react-phone-number-input/style.css'

import api from "assets/services/api";


function ModalUpdateCars(props) {



    const [model, setModel] = useState(props.props.model);
    const [plate, setPlate] = useState(props.props.plate);
    const [capacity, setCapacity] = useState(props.props.capacity);
    const [address, setAddress] = useState(props.props.address);
    const [latitude, setLatitude] = useState(props.props.latitude);
    const [longitude, setLongitude] = useState(props.props.longitude);
    const [number, setNumber] = useState(props.props.number);
    const [neighborhood, setNeighborhood] = useState(props.props.neighborhood);
    const [city, setCity] = useState(props.props.city);
    const [uf, setUf] = useState(props.props.uf);
    const [cep, setCep] = useState(props.props.cep);


    const [br, setBR] = useState(false);
    const [controlSnack, setControlSnack] = useState(false);

    const { storageId } = useAuth();

    const showNotification = place => {
        switch (place) {
            case "br":
                if (!br) {
                    setBR(true);
                    setTimeout(function () {
                        setBR(false);
                        setControlSnack(false);
                    }, 6000);
                }
                break;
            default:
                break;
        }
    };

    useEffect(() => {
        if (controlSnack) showNotification("br")
    }, [controlSnack]);

    async function handleUpdateCars(e) {
        e.preventDefault();
        const response = await api.put('/car/' + props.props.id, {
            model,
            plate: plate,
            capacity: capacity,
            latitude,
            longitude,
            address,
            number,
            neighborhood,
            city,
            uf,
            cep
        });
        if (response.data.error) {
            return alert(response.data.error);
        }
        props.getAllCars();
        props.onHide();
    }

    return (
        <Modal
            {...props}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Editar carro
                </Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleUpdateCars}>
                <Modal.Body>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridname_car">
                            <Form.Label>Modelo</Form.Label>
                            <Form.Control onChange={event => setModel(event.target.value)} value={model} type="text" placeholder="Modelo da carro" />
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridPlate">
                            <Form.Label>Placa</Form.Label>
                            <Form.Control onChange={event => setPlate(event.target.value)} value={plate} type="text" placeholder="Placa do carro" />
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridCapacity">
                            <Form.Label>Capacidade</Form.Label>
                            <Form.Control onChange={event => setCapacity(event.target.value)} value={capacity} type="number" placeholder="Capacidade do carro" />
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} xs={4} controlId="formGridname_car">
                            <Form.Label>Endereço</Form.Label>
                            <Form.Control onChange={event => setAddress(event.target.value)} value={address} type="text" placeholder="Endereço" />
                        </Form.Group>
                        <Form.Group as={Col} xs={1} controlId="formGridPlate">
                            <Form.Label>Numero</Form.Label>
                            <Form.Control onChange={event => setNumber(event.target.value)} value={number} type="text" placeholder="Numero" />
                        </Form.Group>
                        <Form.Group as={Col} xs={3} controlId="formGridCapacity">
                            <Form.Label>Bairro</Form.Label>
                            <Form.Control onChange={event => setNeighborhood(event.target.value)} value={neighborhood} type="text" placeholder="Bairro" />
                        </Form.Group>
                        <Form.Group as={Col} xs={3} controlId="formGridCapacity">
                            <Form.Label>Cidade</Form.Label>
                            <Form.Control onChange={event => setCity(event.target.value)} value={city} type="text" placeholder="Cidade" />
                        </Form.Group>
                        <Form.Group as={Col} xs={1} controlId="formGridCapacity">
                            <Form.Label>Estado</Form.Label>
                            <Form.Control onChange={event => setUf(event.target.value)} value={uf} type="text" placeholder="Estado" />
                        </Form.Group>
                    </Form.Row>
                    <Form.Row className="d-flex justify-content-center">
                        <Form.Group as={Col} xs={2} controlId="formGridname_car">
                            <Form.Label>CEP</Form.Label>
                            <Form.Control onChange={event => setCep(event.target.value)} value={cep} type="text" placeholder="cep" />
                        </Form.Group>
                        <Form.Group as={Col} xs={2} controlId="formGridname_car">
                            <Form.Label>Latitude</Form.Label>
                            <Form.Control onChange={event => setLatitude(event.target.value)} value={latitude} type="text" placeholder="Latitude" />
                        </Form.Group>
                        <Form.Group as={Col} xs={2} controlId="formGridPlate">
                            <Form.Label>Longitude</Form.Label>
                            <Form.Control onChange={event => setLongitude(event.target.value)} value={longitude} type="text" placeholder="Longitude" />
                        </Form.Group>
                    </Form.Row>
                </Modal.Body>
                <Modal.Footer>
                    <div classname_car="d-flex justify-content-center">
                        <Button color="success" type="submit">
                            Editar carro
                        </Button>
                        <Snackbar
                            place="br"
                            color="success"
                            icon={AddAlert}
                            message="Carro editado com sucesso"
                            open={br}
                            closeNotification={() => setBR(false)}
                            close
                        />
                    </div>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default ModalUpdateCars;